import React from "react";

export default function RangeSummary({ loading, items }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-24 rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] animate-pulse" />
        ))}
      </div>
    );
  }

  if (!items?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No data for selected range.</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map(m => (
        <div key={m.id}
          className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-lg bg-[#00ff90]/10 border border-[#00ff90]/20 flex items-center justify-center text-sm font-bold text-[#00ff90]">
              {m.name?.[0]?.toUpperCase() || "?"}
            </div>
            <p className="font-medium text-white truncate">{m.name}</p>
          </div>

          <div className="grid grid-cols-3 gap-2">
            <div className="text-center">
              <p className="text-lg font-bold text-[#00ff90]">{m.presentPct ?? "—"}%</p>
              <p className="text-xs text-white/30 mt-0.5">Present</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-blue-400">{m.avgHours ?? "—"}</p>
              <p className="text-xs text-white/30 mt-0.5">Avg Hrs</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-orange-400">{m.lateCount ?? "—"}</p>
              <p className="text-xs text-white/30 mt-0.5">Late</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}